import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-action-item',
  imports: [TranslateModule],
  template: `
    <div class="admin-action-item">
      @if (titleHint) {
        <div>
          <h3>{{ titleT | translate }}</h3>
          <small>{{ titleHint }}</small>
        </div>
      } @else {
        <h3>{{ titleT | translate }}</h3>
      }
      <ng-content></ng-content>
    </div>
  `,
  styleUrl: './admin-action-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminActionItemComponent {
  @Input({ required: true }) titleT: string;
  @Input({ required: false }) titleHint: string;
}
